<form
  *ngIf="(state$ | async)?.form as form"
  [formGroup]="form"
  class="form">
  <mat-form-field>
    <input
      matInput
      formControlName="titolo"
      [placeholder]="'Titolo' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="tipo"
      [placeholder]="'Tipo' | translate">
  </mat-form-field>
</form>
